import React, { useState } from 'react';
import { useIntl } from 'react-intl';
import {
  StyledSection,
  StyledContentBlock,
  MainContainer,
  MainWrapper,
  FooterGrid,
  FooterColumn,
  ColumnTitle,
  StoreWrapper,
  GooglePlay,
  GooglePlayImageWrapper,
  AppStore,
  AppStoreImageWrapper,
  LinkList,
  LinkItem,
  StyledLink,
  DownWrapper,
  LogoContentWrapper,
  LogoImage,
  Copyright,
  CopyrightText,
  MobileWrapper,
  MobileDownloadSection,
  MobileLinkWrapper,
  MobileSectionSeparator,
  MobileSectionHeader,
  MobileSectionTitle,
  ToggleIcon,
  MobileSectionContent,
  MobileLinkList,
  MobileLinkItem,
  MobileLink,
  MobileFooterBottom,
  MobileLogoWrapper,
  MobileCopyright,
} from './styled';

const Footer = () => {
  const { messages } = useIntl();
  const [expandedSection, setExpandedSection] = useState(null);

  const toggleSection = sectionId => {
    if (expandedSection === sectionId) {
      setExpandedSection(null);
    } else {
      setExpandedSection(sectionId);
    }
  };

  const findLinksById = id => {
    const found = messages['home.footer.links'].find(item => item.id === id);
    return found ? found.links : [];
  };

  const findTitleById = id => {
    const found = messages['home.footer.links'].find(item => item.id === id);
    return found ? found.message : '';
  };

  const mobileSections = [
    { id: 'company' },
    { id: 'insights' },
    { id: 'products' },
    { id: 'reviews' },
    { id: 'follow' },
  ];

  return (
    <StyledSection>
      <StyledContentBlock>
        <MainContainer>
          <MainWrapper>
            <FooterGrid>
              <FooterColumn>
                <ColumnTitle>Download App</ColumnTitle>
                <StoreWrapper>
                  <GooglePlay>
                    {/* eslint-disable-next-line react/jsx-no-target-blank */}
                    <a
                      href={messages['home.footer.playstore.link']}
                      target="_blank"
                    >
                      <GooglePlayImageWrapper>
                        <img
                          src={messages['home.footer.playstore.src']}
                          alt={messages['home.footer.playstore.alt']}
                        />
                      </GooglePlayImageWrapper>
                    </a>
                  </GooglePlay>
                  <AppStore>
                    {/* eslint-disable-next-line react/jsx-no-target-blank */}
                    <a
                      href={messages['home.footer.appstore.link']}
                      target="_blank"
                    >
                      <AppStoreImageWrapper>
                        <img
                          src={messages['home.footer.appstore.src']}
                          alt={messages['home.footer.appstore.alt']}
                        />
                      </AppStoreImageWrapper>
                    </a>
                  </AppStore>
                </StoreWrapper>
              </FooterColumn>
              <FooterColumn>
                <ColumnTitle>{findTitleById('company')}</ColumnTitle>
                <LinkList>
                  {findLinksById('company').map((link, linkIndex) => (
                    // eslint-disable-next-line react/no-array-index-key
                    <LinkItem key={`company-${linkIndex}`}>
                      <StyledLink href={link.href} target="_blank">
                        {link.message}
                      </StyledLink>
                    </LinkItem>
                  ))}
                </LinkList>
              </FooterColumn>
              <FooterColumn>
                <ColumnTitle>{findTitleById('insights')}</ColumnTitle>
                <LinkList>
                  {findLinksById('insights').map((link, linkIndex) => (
                    // eslint-disable-next-line react/no-array-index-key
                    <LinkItem key={`insights-${linkIndex}`}>
                      <StyledLink href={link.href} target="_blank">
                        {link.message}
                      </StyledLink>
                    </LinkItem>
                  ))}
                </LinkList>
              </FooterColumn>
              <FooterColumn>
                <ColumnTitle>{findTitleById('products')}</ColumnTitle>
                <LinkList>
                  {findLinksById('products').map((link, linkIndex) => (
                    // eslint-disable-next-line react/no-array-index-key
                    <LinkItem key={`products-${linkIndex}`}>
                      <StyledLink href={link.href} target="_blank">
                        {link.message}
                      </StyledLink>
                    </LinkItem>
                  ))}
                </LinkList>
              </FooterColumn>
              <FooterColumn>
                <ColumnTitle>{findTitleById('reviews')}</ColumnTitle>
                <LinkList>
                  {findLinksById('reviews').map((link, linkIndex) => (
                    // eslint-disable-next-line react/no-array-index-key
                    <LinkItem key={`reviews-${linkIndex}`}>
                      <StyledLink href={link.href} target="_blank">
                        {link.message}
                      </StyledLink>
                    </LinkItem>
                  ))}
                </LinkList>
              </FooterColumn>
              <FooterColumn>
                <ColumnTitle>{findTitleById('follow')}</ColumnTitle>
                <LinkList>
                  {findLinksById('follow').map((link, linkIndex) => (
                    // eslint-disable-next-line react/no-array-index-key
                    <LinkItem key={`follow-${linkIndex}`}>
                      <StyledLink href={link.href} target="_blank">
                        {link.message}
                      </StyledLink>
                    </LinkItem>
                  ))}
                </LinkList>
              </FooterColumn>
            </FooterGrid>
            <DownWrapper>
              <LogoContentWrapper>
                <LogoImage
                  src={messages['home.footer.logo.src']}
                  alt={messages['home.footer.logo.alt']}
                />
              </LogoContentWrapper>
              <Copyright>
                <CopyrightText>
                  {messages['home.footer.copyright']}
                </CopyrightText>
              </Copyright>
            </DownWrapper>
          </MainWrapper>
          <MobileWrapper>
            <MobileDownloadSection>
              <ColumnTitle>Download App</ColumnTitle>
              <StoreWrapper>
                <GooglePlay>
                  {/* eslint-disable-next-line react/jsx-no-target-blank */}
                  <a
                    href={messages['home.footer.playstore.link']}
                    target="_blank"
                  >
                    <GooglePlayImageWrapper>
                      <img
                        src={messages['home.footer.playstore.src']}
                        alt={messages['home.footer.playstore.alt']}
                      />
                    </GooglePlayImageWrapper>
                  </a>
                </GooglePlay>
                <AppStore>
                  {/* eslint-disable-next-line react/jsx-no-target-blank */}
                  <a
                    href={messages['home.footer.appstore.link']}
                    target="_blank"
                  >
                    <AppStoreImageWrapper>
                      <img
                        src={messages['home.footer.appstore.src']}
                        alt={messages['home.footer.appstore.alt']}
                      />
                    </AppStoreImageWrapper>
                  </a>
                </AppStore>
              </StoreWrapper>
            </MobileDownloadSection>
            <MobileLinkWrapper>
              <MobileSectionSeparator />
              {mobileSections.map(section => (
                <React.Fragment key={section.id}>
                  <MobileSectionHeader
                    onClick={() => toggleSection(section.id)}
                  >
                    <MobileSectionTitle>
                      {findTitleById(section.id)}
                    </MobileSectionTitle>
                    <ToggleIcon>
                      {expandedSection === section.id ? (
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          width="31"
                          height="31"
                          viewBox="0 0 31 31"
                          fill="none"
                        >
                          <g clipPath="url(#clip0_6344_99941)">
                            <path
                              d="M15.6875 30.3477C23.9718 30.3477 30.6875 23.6319 30.6875 15.3477C30.6875 7.06338 23.9718 0.347656 15.6875 0.347656C7.40322 0.347656 0.6875 7.06338 0.6875 15.3477C0.6875 23.6319 7.40322 30.3477 15.6875 30.3477Z"
                              fill="#FF9500"
                            />
                            <path
                              d="M21 16.6049V15.0879H10V16.6049H21Z"
                              fill="black"
                            />
                          </g>
                          <defs>
                            <clipPath id="clip0_6344_99941">
                              <rect
                                width="31"
                                height="30"
                                fill="white"
                                transform="translate(0 0.347656)"
                              />
                            </clipPath>
                          </defs>
                        </svg>
                      ) : (
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          width="31"
                          height="31"
                          viewBox="0 0 31 31"
                          fill="none"
                        >
                          <g clipPath="url(#clip0_6344_99941)">
                            <path
                              d="M15.6875 30.3477C23.9718 30.3477 30.6875 23.6319 30.6875 15.3477C30.6875 7.06338 23.9718 0.347656 15.6875 0.347656C7.40322 0.347656 0.6875 7.06338 0.6875 15.3477C0.6875 23.6319 7.40322 30.3477 15.6875 30.3477Z"
                              fill="#FF9500"
                            />
                            <path
                              d="M16.2592 10.3477H14.7422V21.3477H16.2592V10.3477Z"
                              fill="black"
                            />
                            <path
                              d="M21 16.6049V15.0879H10V16.6049H21Z"
                              fill="black"
                            />
                          </g>
                          <defs>
                            <clipPath id="clip0_6344_99941">
                              <rect
                                width="31"
                                height="30"
                                fill="white"
                                transform="translate(0 0.347656)"
                              />
                            </clipPath>
                          </defs>
                        </svg>
                      )}
                    </ToggleIcon>
                  </MobileSectionHeader>
                  <MobileSectionContent
                    isExpanded={expandedSection === section.id}
                  >
                    <MobileLinkList>
                      {findLinksById(section.id).map((link, linkIndex) => (
                        <MobileLinkItem
                          // eslint-disable-next-line react/no-array-index-key
                          key={`mobile-${section.id}-${linkIndex}`}
                        >
                          <MobileLink href={link.href} target="_blank">
                            {link.message}
                          </MobileLink>
                        </MobileLinkItem>
                      ))}
                    </MobileLinkList>
                  </MobileSectionContent>
                </React.Fragment>
              ))}
            </MobileLinkWrapper>
            <MobileFooterBottom>
              <MobileLogoWrapper>
                <LogoImage
                  src={messages['home.footer.logo.src']}
                  alt={messages['home.footer.logo.alt']}
                />
              </MobileLogoWrapper>
              <MobileCopyright>
                {messages['home.footer.copyright']}
              </MobileCopyright>
            </MobileFooterBottom>
          </MobileWrapper>
        </MainContainer>
      </StyledContentBlock>
    </StyledSection>
  );
};

export default Footer;
